import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  selectAllUserInfoAction,
  selectUserInfoAction,
  selectUserMoneyAction,
  selectUserGoldDetailsAction,
  selectUserSilverDetailsAction,
  selectUserFriendsAction,
  selectChantRecordAction,
  selectUserGroupAction,
  selectNextListAction,
  selectGroupChantRecordAction,
  selectGroupListAction,
  selectGroupManListAction,
  selectdrawPeriodListAction,
  getUserAvatarAction,
  selectUserBankAction,
  getUserReportConfigAction,
  fixReportStatusAction,
  circleOffrienesConfigAction,
  GetGoldCoinAction,
  selectprizesyncAction
} from "../action/userManagementAction";

export const userManagementReducer = (
  builder: ActionReducerMapBuilder<{
    allUserInfoList: any;
    userProfile: any;
    money: any;
    goldDetails: any;
    silverDetails: any;
    userFrindsList: any;
    chantRecord: any;
    userGroupList: any;
    nextList: any;
    groupChantRecord: any;
    allGroupList: any;
    groupManList: any;
    drawPeriodList: any;
    prizesync: any;
    avatar: any;
    userBank: any;
    userReportConfig: any;
    fixReportStatus: any;
    circleOffriendsConfig: any;
    getGoldCoinConfig: any;
  }>
) => {
  builder.addCase(selectAllUserInfoAction.fulfilled, (state, { payload }) => {
    state.allUserInfoList = payload;
  });
  builder.addCase(selectUserInfoAction.fulfilled, (state, { payload }) => {
    state.userProfile = payload;
  });
  builder.addCase(selectUserMoneyAction.fulfilled, (state, { payload }) => {
    state.money = payload;
  });
  builder.addCase(
    selectUserGoldDetailsAction.fulfilled,
    (state, { payload }) => {
      state.goldDetails = payload;
    }
  );
  builder.addCase(
    selectUserSilverDetailsAction.fulfilled,
    (state, { payload }) => {
      state.silverDetails = payload;
    }
  );
  builder.addCase(selectUserFriendsAction.fulfilled, (state, { payload }) => {
    state.userFrindsList = payload;
  });
  builder.addCase(selectChantRecordAction.fulfilled, (state, { payload }) => {
    state.chantRecord = payload;
  });
  builder.addCase(selectUserBankAction.fulfilled, (state, { payload }) => {
    state.userBank = payload;
  });

  builder.addCase(
    selectGroupChantRecordAction.fulfilled,
    (state, { payload }) => {
      state.groupChantRecord = payload;
    }
  );
  builder.addCase(selectUserGroupAction.fulfilled, (state, { payload }) => {
    state.userGroupList = payload;
  });
  builder.addCase(selectNextListAction.fulfilled, (state, { payload }) => {
    state.nextList = payload;
  });
  builder.addCase(selectGroupListAction.fulfilled, (state, { payload }) => {
    state.allGroupList = payload;
  });
  builder.addCase(selectGroupManListAction.fulfilled, (state, { payload }) => {
    state.groupManList = payload;
  });
  builder.addCase(selectdrawPeriodListAction.fulfilled, (state, { payload }) => {
    state.drawPeriodList = payload;
  });
  builder.addCase(selectprizesyncAction.fulfilled, (state, { payload }) => {
    state.prizesync = payload;
  });
  builder.addCase(getUserAvatarAction.fulfilled, (state, { payload }) => {
    state.avatar = payload;
  });
  builder.addCase(getUserReportConfigAction.fulfilled, (state, { payload }) => {
    state.userReportConfig = payload
  })
  builder.addCase(fixReportStatusAction.fulfilled, (state, payload) => {
    state.fixReportStatus = payload
  })
  builder.addCase(circleOffrienesConfigAction.fulfilled, (state, { payload }) => {
    state.circleOffriendsConfig = payload;
  })
  builder.addCase(GetGoldCoinAction.fulfilled, (state, { payload }) => {
    state.getGoldCoinConfig = payload;
  })
};
